export function CloseIcon({ className }: { className?: string }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="12" cy="12" r="12" fill="url(#paint0_linear_3682_11293)"/>
      <path d="M16.5527 8.55654L15.6358 7.63281L12.0009 11.295L8.36607 7.63281L7.44922 8.55654L11.0841 12.2187L7.44922 15.8808L8.36607 16.8045L12.0009 13.1424L15.6358 16.8045L16.5527 15.8808L12.9178 12.2187L16.5527 8.55654Z" fill="white"/>
      <defs>
        <linearGradient id="paint0_linear_3682_11293" x1="-4.54545" y1="3.30653e-06" x2="25.4519" y2="2.73733" gradientUnits="userSpaceOnUse">
          <stop offset="0.00961538" stopColor="#F15A29"/>
          <stop offset="0.413462" stopColor="#F6881F"/>
          <stop offset="0.649038" stopColor="#F7941D"/>
          <stop offset="1" stopColor="#EF4130"/>
        </linearGradient>
      </defs>
    </svg>
  );
}
